import { render, staticRenderFns } from "./RelievePrimaryAssignment.vue?vue&type=template&id=a6fb569a&scoped=true"
import script from "./RelievePrimaryAssignment.vue?vue&type=script&lang=js"
export * from "./RelievePrimaryAssignment.vue?vue&type=script&lang=js"
import style0 from "./RelievePrimaryAssignment.vue?vue&type=style&index=0&id=a6fb569a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6fb569a",
  null
  
)

export default component.exports